import { useNavigate } from "react-router-dom";
import { getCurrentUser } from 'aws-amplify/auth';
import { useState, useEffect } from "react";
import Home from "../home"

export const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState({ user: '', isLoggedIn: false, loginDate: null });
  const msBetweenDates = Math.abs(Date.now() - user.loginDate);

  // 👇️ convert ms to hours                  min  sec   ms
  const hoursBetweenDates = msBetweenDates / (60 * 60 * 1000);
  const needsAuthCheck = !user || user.isLoggedIn === false || hoursBetweenDates > 24;

  useEffect(() => {
    if (needsAuthCheck) {
      getCurrentUser()
        .then((adfsUser) => setUser({ user: adfsUser.username, isLoggedIn: true, loginDate: Date.now() }))
        .catch((ex) => { console.log(JSON.stringify(ex)) });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [needsAuthCheck]);

  if (needsAuthCheck) {
    // user is not authenticated
    return <Home />;
  } else {
    return children;
  }
};